<template>
  <div v-if="user" id="app">
    <div id="sidebar">
      <ul>
        <router-link
          class="sidebar-item"
          to="/"
          exact
          tag="li"
          v-bind:class="{ 'router-link-active': this.$route.name === 'home' }"
        >
          <div
            class="foldout-item"
            @mouseover="hjemActive=true"
            @mouseleave="hjemActive=false"
          >
            <div class="icon-wrapper">
              <IconHjemActive
                v-if="this.$route.name === 'home' || hjemActive"
                :width=27
                :height=24
                icon-name="Hjem"
              />
              <IconHjem
                v-else
                :width=27
                :height=24
                icon-name="Hjem"
              />
            </div>
            <transition name="fade">
              <div
                v-if="hjemActive"
                class="foldout-item-title"
              >
                Hjem
              </div>
            </transition>
          </div>
        </router-link>
        <router-link
          class="sidebar-item"
          to="/map"
          tag="li"
        >
          <div
            class="foldout-item"
            @mouseover="retvejkodeActive=true"
            @mouseleave="retvejkodeActive=false"
          >
            <div class="icon-wrapper">
              <IconRetVejkodeActive
                v-if="this.$route.name === 'map' || retvejkodeActive"
                :width=27
                :height=24
                icon-name="Ret vejkode"
              />
              <IconRetVejkode
                v-else
                :width=27
                :height=24
                icon-name="Ret vejkode"
              />
            </div>
            <transition name="fade">
              <div
                v-if="retvejkodeActive"
                class="foldout-item-title"
              >
                Ret Vejkoder
              </div>
            </transition>
          </div>
        </router-link>
      </ul>
      <router-link to="/user" tag="div" id="avatar">
        <Avatar v-bind:user="user" />
      </router-link>
    </div>
    <router-view/>
  </div>
  <div v-else>
    <router-view/>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import IconHjem from '@/components/common/Icon/IconHjem/IconHjem.vue';
import IconHjemActive from '@/components/common/Icon/IconHjem/IconHjemActive.vue';
import IconRetVejkode from '@/components/common/Icon/IconRetVejkode/IconRetVejkode.vue';
import IconRetVejkodeActive from '@/components/common/Icon/IconRetVejkode/IconRetVejkodeActive.vue';
export default {
  name: 'app',
  components: {
    Avatar,
    IconHjem,
    IconHjemActive,
    IconRetVejkode,
    IconRetVejkodeActive,
  },
  computed: {
    user () {
      return this.$store.state.user;
    },
  },
  data: function () {
    return {
      hjemActive: false,
      retvejkodeActive: false,
    };
  },
};
</script>

<style lang="scss">
$sidebar-width: 80px;

html {
  height: 100vh;
  box-sizing: border-box;
  background-color: $background-color;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
  font-family: 'Open Sans', 'sans-serif';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $text-color;
}

h1,h2,h3,h4 {
  font-weight: 600;
  color: #3B3B3B;
  font-family: 'Open Sans', 'sans-serif';
  line-height: 26px;
}
h1 {
  font-size: 20px;
}

h2 {
  font-size: 16px;
  color: #686868;
}

a {
  color: $default-color;
}
#app {
  display: flex;
  height: 100vh;
}
#sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: $sidebar-width;
  z-index:2;
  align-items: center;
  box-shadow: 0 2px 20px 0 rgba(92,109,150,0.20);
  background-color: #FFFFFF;
  padding: 0 0 14px 0;
}

#sidebar ul{
  list-style: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  width: 100%;
}
.sidebar-item {
  font-weight: 600;
  color: $text-color;
  height: 70px;
}
.sidebar-item:hover{
  color: $default-color-light;
}
.sidebar-item.router-link-active {
  text-decoration: none;
  border-right: $default-color solid 4px;
  color: $default-color;
  background-color: $default-color-background-light;
}

.sidebar-item.router-link-active:hover {
  color: $default-color-light;
}

.icon-wrapper {
  padding: $sidebar-width/3;
}
.foldout-item {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  white-space: nowrap;
  transition: width $transition-length;
}
.foldout-item:hover {
  width: 190px;
  border-right: $default-color solid 4px;
  background-color: $default-color-background-light;
  box-shadow: 0 2px 4px 0 rgba(92,109,150,0.30);
}

.foldout-item-title {
  margin-left: -10px;
  color: $default-color;
  // transition: color $transition-length $transition-length;
}
.fade-enter-active {
  transition: color $transition-length $transition-length;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  color: transparent;
}

// #avatar {
//   justify-self: end;
// }
</style>
